import { render, staticRenderFns } from "./shopsInput.vue?vue&type=template&id=03da8903&"
import script from "./shopsInput.vue?vue&type=script&lang=js&"
export * from "./shopsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports